import { useContext, createContext, ReactNode } from "react";
import RootStore from "../store/modquiz/root.store";

// holds a reference to the store (singleton)
let store: RootStore | undefined;

// create the context
const StoreContext = createContext<RootStore | undefined>(undefined);

// create the provider component
export function RootStoreProvider({ children }: { children: ReactNode }) {
  //only create the store once ( store is a singleton)
  if (!store) {
    store = new RootStore(localStorage);
  }

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

// create the hook
export function useRootStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error("useRootStore must be used within RootStoreProvider");
  }

  return context;
}
